import React from "react";
import "../tutorRegistration/TutorRegistration.css";

const StepContact = ({
  formData,
  setFormData,
  errors,
  handleInputChange,
  handleFileChange,
}) => {
  return (
    <>
      <div className="form-title">
        <h2>Contact Person Information</h2>
        <p className="subtitle">
          Please share your information, as we think you will be the account
          administrator.
        </p>
      </div>

      <div className="form-group name-group">
        <div className="name-fields">
          <div className="form-group half-width">
            <label>First Name *</label>
            <input
              type="text"
              name="adminFirstName"
              placeholder="Enter first name"
              value={formData.adminFirstName || ""}
              onChange={handleInputChange}
              className="tutor-input-field"
              required
            />
            {errors.adminFirstName && (
              <p className="error">{errors.adminFirstName}</p>
            )}
          </div>
          <div className="form-group half-width">
            <label>Last Name *</label>
            <input
              type="text"
              name="adminLastName"
              placeholder="Enter last name"
              value={formData.adminLastName || ""}
              onChange={handleInputChange}
              className="tutor-input-field"
              required
            />
            {errors.adminLastName && (
              <p className="error">{errors.adminLastName}</p>
            )}
          </div>
        </div>
      </div>

      <div className="form-group">
        <label>Email *</label>
        <input
          type="email"
          name="adminEmail"
          placeholder="admin@example.com"
          value={formData.adminEmail || ""}
          onChange={handleInputChange}
          className="tutor-input-field"
          required
        />
        {errors.adminEmail && <p className="error">{errors.adminEmail}</p>}
        <p className="tooltip">
          This email will be used for account administration and notifications.
        </p>
      </div>
      <div className="form-group">
        <label>Phone Number</label>

        <div className="phone-input-wrapper">
          <span className="phone-prefix">+234</span>

          <input
            type="tel"
            name="adminPhone"
            value={formData.adminPhone || ""}
            maxLength={10}
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, "");

              if (value.startsWith("0")) {
                value = value.substring(1);
              }

              setFormData({ ...formData, adminPhone: value });
            }}
            placeholder="801 234 5678"
            className="phone-input"
          />
        </div>

        {errors.adminPhone && <p className="error">{errors.adminPhone}</p>}
      </div>

      {/* <div className="form-group">
        <label>Phone Number *</label>
        <input
          type="tel"
          name="adminPhone"
          placeholder="(+234) 80 000 000 11"
          value={formData.adminPhone || ""}
          onChange={handleInputChange}
          className="tutor-input-field"
          required
        />
        {errors.adminPhone && <p className="error">{errors.adminPhone}</p>}
        <p className="tooltip">
          Provide an active phone number for contact and verification.
        </p>
      </div> */}

      <div className="form-group">
        <label>Identity Card (NIN/Passport/Driver License) *</label>
        <input
          type="file"
          name="id"
          accept="image/*,application/pdf"
          onChange={(e) => handleFileChange(e, "adminId")}
          className="tutor-input-field"
          required
        />
        {errors.adminId && <p className="error">{errors.adminId}</p>}
        <p className="note">
          Upload a valid government-issued ID for the account administrator (PDF
          or image, max 5MB).
        </p>
      </div>
    </>
  );
};

export default StepContact;
